import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Dialog = styled.div`
  width: 650px;
  background-color: ${ColorSF2.lightGray};
  @media (max-height: 700px) {
    height: 510px;
    overflow-y: auto;
  }
  @media (max-height: 500px) {
    height: 300px;
  }
`;

export const TabDetail = styled.div`
  @media (max-height: 530px) {
    // max-height: 210px;
    margin: 0px 10px 0px 10px;
    // overflow-y: auto;
  }
`;
const getButtonColor = type => {
  switch (type) {
    case 'update':
      return ColorSF2.navyBlue;
    case 'delete':
      return ColorSF2.red;
    default:
      return ColorSF2.navyBlue;
  }
};
export const BaseButton = styled.div`
  background-color: ${props => getButtonColor(props.btnType)};
  color: ${ColorSF2.white};
  width: 150px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-size: 15px;
  font-weight: bold;
  @media (max-height: 530px) {
    height: 30px;
  }
`;
export const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const Tab = styled.div`
  display: flex;
  flex: 1;
  margin: 5px;
  height: 50px;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: ${props => (props.current ? 'default' : 'pointer')};
  background-color: ${props =>
    props.current ? ColorSF2.skyBlue : ColorSF2.paleBlue};
  @media (max-height: 530px) {
    height: 30px;
    padding: 5px;
  }
`;
export const SubmitWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  @media (max-height: 530px) {
    margin: 10px 0;
  }
`;

export const Operation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
